// TODO: Dropdown component code copied from manager and will be extracted
import type { FC, ReactElement } from 'react'

import Dropdown from 'react-dropdown'
import { twJoin } from 'tailwind-merge'

import 'react-dropdown/style.css'

export const DemoCustomerTabs: FC<{
  className?: string
  tabs: { value: number; label: string | ReactElement }[]
  selectedValue: number
  isTabChangeable?: boolean
  onClick?: (val: number | string) => void
}> = ({ className, tabs, selectedValue, isTabChangeable = true, onClick = () => {} }) => {
  const dropdownValues = tabs.map(option => ({
    value: String(option.value),
    label: option.label,
  }))

  return (
    <div>
      <div
        className={twJoin(className, 'mobile:flex shadow-basic mb-6 hidden truncate rounded-lg')}
      >
        {tabs.map((tab, idx) => {
          const { value, label } = tab
          return (
            <button
              type="button"
              disabled={!isTabChangeable && value !== selectedValue}
              key={idx}
              className={twJoin(
                'm-0 flex-shrink flex-grow basis-[7rem] cursor-pointer rounded-b-[0.2rem] rounded-e-none rounded-s-[0.2rem] rounded-t-none',
                'border-0 border-b-[0.18rem] border-solid',
                'bg-[#fff] px-0 pb-3 pt-4 text-base transition duration-150 ease-out',
                'hover:border-b-[#f3852c] hover:text-[#df6b0d] focus:border-b-[#f3852c] focus:text-[#df6b0d] active:border-b-[#f3852c] active:text-[#df6b0d] disabled:cursor-not-allowed',
                value === selectedValue
                  ? 'border-b-[#f3852c] text-[#df6b0d]'
                  : 'border-b-transparent'
              )}
              onClick={() => onClick(value)}
            >
              {label}
            </button>
          )
        })}
      </div>

      <Dropdown
        // @ts-ignore
        tabIndex={0}
        className="mobile:hidden mb-6 flex"
        value={dropdownValues.find(option => option.value === String(selectedValue))}
        onChange={({ value }) => onClick(isNaN(Number(value)) ? value : Number(value))}
        options={dropdownValues}
      />
    </div>
  )
}
